import React, { useState, useEffect } from "react";
import LibraryBox from "./LibraryBox";
import axios from "../../../../../axios"
const LibraryPropsBox = ({
  filter,
  setFilter,
  selectedQuestion,
  setSelectedQuestion,
  libraryQuestions,
  setLibraryQuestions,
  setSelQueID,
  questions,
  sourceLibrary,
  getquestiondata,
  assessmentDetails
}) => {
  const {
    domain,
    skill,
    bookChapter,
    standard,
    section,
    subject,
    difficultyLevel,
    page,
    limit,
    name
  } = filter;
  const [isInProgress, setIsInProgress] = useState(true);

  const getSchoolLibraryQuestionList = async () => {
    setIsInProgress(true);
    let res = await axios.get(
      `/api/v1/question/filter?_page=${page}&_limit=${limit}&standardId=${standard?.id}&sectionId=${section?.id}&subjectId=${subject?.id}` +
      `${bookChapter?.bookId ? `&bookId=${bookChapter?.bookId}` : ``}` +
      `${bookChapter?.bookId ? `&chapterId=${bookChapter?.chapterId}` : ``
      }` +
      `${domain?.id ? `&domainId=${domain?.id}` : ``}` +
      `${skill?.id ? `&skillId=${skill?.id}` : ``}` +
      `${difficultyLevel ? `&difficultyLevelId=${difficultyLevel?.id}` : ``
      }`
    );
    console.log("FilterRes", res)
    // res && setLibraryQuestions((prev) => [...prev, ...res.data.data]);
    if (res && res.data.data && questions && questions.length > 0) {
      const filteredQuestions = res.data.data.filter(
        (question) => !questions.some((q) => q.id === question.id)
      );
      setLibraryQuestions(filteredQuestions);
    } else {
      res && setLibraryQuestions(res.data.data);
    }
    setIsInProgress(false);
  };


  const getB4SLibraryQuestionList = async () => {
    setIsInProgress(true);
    let res = await axios.get(
      `/api/v1/b4sQuestion/filter?_page=${page}&_limit=${limit}&standardId=${standard?.id}&sectionId=${section?.id}&subjectId=${subject?.id}` +
      `${bookChapter?.bookId ? `&bookId=${bookChapter?.bookId}` : ``}` +
      `${bookChapter?.bookId ? `&chapterId=${bookChapter?.chapterId}` : ``
      }` +
      `${domain?.id ? `&domainId=${domain?.id}` : ``}` +
      `${skill?.id ? `&skillId=${skill?.id}` : ``}` +
      `${difficultyLevel ? `&difficultyLevelId=${difficultyLevel?.id}` : ``
      }`
    );
    console.log("FilterRes", res)
    // res && setLibraryQuestions((prev) => [...prev, ...res.data.data]);
    if (res && res.data.data && questions && questions.length > 0) {
      const filteredQuestions = res.data.data.filter(
        (question) => !questions.some((q) => q.id === question.id)
      );
      setLibraryQuestions(filteredQuestions);
    } else {
      res && setLibraryQuestions(res.data.data);
    }
      getquestiondata(res)
    setIsInProgress(false);
  };


  useEffect(() => {
    if(sourceLibrary == "FROM_SCHOOL_LIBRARY"){
      getSchoolLibraryQuestionList();
    }else{
      getB4SLibraryQuestionList();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [domain, skill, bookChapter, difficultyLevel, questions]);

  const handelInfiniteScroll = async () => {
    try {
      if (
        document.getElementById("total-assessment-library-question")
          .clientHeight +
        document.getElementById("total-assessment-library-question")
          .scrollTop +
        1 >=
        document.getElementById("total-assessment-library-question")
          .scrollHeight
      ) {
        setFilter((prevState) => ({ ...prevState, page: prevState.page + 1 }));
      }
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    const element = document.getElementById(
      "total-assessment-library-question"
    );
    if (element) {
      element.addEventListener("scroll", handelInfiniteScroll);
    }

    return () => {
      if (element) {
        element.removeEventListener("scroll", handelInfiniteScroll);
      }
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [page]);
  return (
    <>
      {libraryQuestions?.length > 0 ? (
        <div
          id="total-assessment-library-question"
          className="d-flex flex-wrap gap-3"
        >
          {libraryQuestions?.map((question, index) => (
            <LibraryBox
              key={index}
              question={question}
              selectedQuestion={selectedQuestion}
              setSelectedQuestion={setSelectedQuestion}
              libraryQuestions={libraryQuestions}
              setSelQueID={setSelQueID}
              sourceLibrary={sourceLibrary}
              assessmentDetails={assessmentDetails}
            />
          ))}
        </div>
      ) : isInProgress ? (
        <div style={{ width: "100vw" }}>
          <img
            style={{ marginLeft: "32%", width: "80px", height: "70px" }}
            className="ongoing_loader"
            src="/gif/LoaderDot.gif"
            alt=""
          />
        </div>
      ) : (
        <span>Questions Not Found</span>
      )}
    </>
  );
};

export default LibraryPropsBox;
